import React, { FC, MouseEvent } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Member } from '../../@types/member'
import { Prefix } from '../../@types/prefix'
import { makePath } from '../../helpers/path'
import { useLocation } from 'react-router'
import { useDispatch } from 'react-redux'
import AuthService from '../../services/auth'
import { setUser } from '../../store/user/user.actions'
import { prefixAllow } from '../../helpers/prefixAllow'

interface BottomBarProps {
	prefix?: Prefix
	member: Member | undefined
}
const BottomBar: FC<BottomBarProps> = ({ member, prefix }) => {
	const history = useHistory()
	const loc = useLocation()
	const dispatch = useDispatch()
	const playgameMotion = prefix?.playgameMotion === "" || prefix?.playgameMotion === "dance" ? "dance" : prefix?.playgameMotion;

	const launchGame = (e: MouseEvent<any>) => {
		e.preventDefault()

		if (!member?.game.meta) {
			toast.error('กรุณาฝากเงินครั้งแรกเพื่อเข้าเล่นเกม')
			return
		}
		// history.push(makePath('/launch-game', [`t=${Date.now() + 5000}`]))
		history.push(makePath('/launch-game'))
	}

	const refetchCredit = async () => {
		try {
			const res = await AuthService.getMemberInfo(true)
			dispatch(setUser(res))
		} catch ({ message }: any) {
			toast.error(message as string)
		}
	}

	return (
		<div className={`bottombar-mobile ${prefix?.prefix === 'FZ555' ? 'bottombar-dark' : ''}`}>
			<ul className="nav-menu">
				<li className="nav-item">
					<Link
						to={makePath('/wallet')}
						onClick={() => { refetchCredit() }}
						className={`nav-link ${loc.pathname === '/wallet' && 'active'}`}
					>
						<img src={`/icons/3d-new/wallet.png`} alt="icon" />
						<span>กระเป๋า</span>
					</Link>
				</li>
				<li className="nav-item">
					<Link
						to={makePath('/deposit')}
						className={`nav-link ${(loc.pathname === '/deposit' || loc.pathname === '/deposit/bank') && 'active'}`}
					>
						<img src={prefixAllow.includes(prefix?.prefix as string) ? `/icons/3d-new2/deposit.png` : `/icons/3d-new/deposit.png`} alt="icon" />
						<span>เติมเงิน</span>
					</Link>
				</li>
				<li className="nav-item middle-item">
					<a href="#game" className={`nav-link ${loc.pathname === '/launch-game' && 'active'}`} onClick={launchGame}>
						<div className={`icon-button-container ${playgameMotion}`}>
							<div className="icon-button">
								<div className="icon-container" />
							</div>
							{prefix?.playgameImage ?
								<img className="icon-center" src={prefix?.playgameImage} alt="icon" /> :
								<img className="icon-center" src={`/icons/new/play_new.png`} alt="icon" />
							}
						</div>
						<span>เข้าเล่นเกม</span>
					</a>
				</li>
				<li className="nav-item">
					<Link
						to={makePath('/promotion')}
						className={`nav-link ${loc.pathname === '/promotion' && 'active'}`}
					>
						<img src={prefixAllow.includes(prefix?.prefix as string) ? `/icons/3d-new2/promotion.png` : `/icons/3d-new/promotion.png`} alt="icon" />
						<span>โปรโมชั่น</span>
					</Link>
				</li>
				<li className="nav-item">
					<Link
						to={makePath('/profile')}
						className={`nav-link ${loc.pathname === '/profile' && 'active'}`}
					>
						<img src={prefixAllow.includes(prefix?.prefix as string) ? `/icons/3d-new2/account.png` : `/icons/3d-new/account.png`} alt="icon" />
						<span>โปรไฟล์</span>
					</Link>
				</li>
			</ul>
		</div>
	)
}

export default BottomBar
